export const APIKEY_LOAD_REQUEST = 'APIKEY_LOAD_REQUEST';
export const APIKEY_LOAD_SUCCESS = 'APIKEY_LOAD_SUCCESS';
export const APIKEY_LOAD_FAILURE = 'APIKEY_LOAD_FAILURE';
export const APIKEY_RESET_REQUEST = 'APIKEY_RESET_REQUEST';
